import React from 'react'
import { Flex, Heading, Text } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'

export const MSG = defineMessages({
  buyersMarket: {
    id: 'MarketTemperature.buyersMarket',
    defaultMessage: "buyer's market"
  },
  buyersMarketDescription: {
    id: 'MarketTemperature.buyersMarketDescription',
    defaultMessage: 'Better deals and less competition'
  },
  sellersMarket: {
    id: 'MarketTemperature.sellersMarket',
    defaultMessage: "seller's market"
  },
  sellersMarketDescription: {
    id: 'MarketTemperature.sellersMarketDescription',
    defaultMessage: 'Rising values but more competition'
  }
})

export const MarketLabels: React.FC = () => {
  const intl = useIntl()

  return (
    <Flex justify='space-between' marginTop={8} mb={8}>
      <Flex flexDirection='column' flex={1} textAlign='left'>
        <Heading variant='eyebrow' size='2xs' fontWeight='semibold' color='primary.700' mb={1} textAlign='left'>
          {intl.formatMessage(MSG.buyersMarket)}
        </Heading>
        <Text size='2xs' color='neutral.700' whiteSpace='wrap'>
          {intl.formatMessage(MSG.buyersMarketDescription)}
        </Text>
      </Flex>
      <Flex flexDirection='column' textAlign='right' flex={1}>
        <Heading variant='eyebrow' size='2xs' fontWeight='semibold' color='brand.700' mb={1} textAlign='right'>
          {intl.formatMessage(MSG.sellersMarket)}
        </Heading>
        <Text size='2xs' color='neutral.700' whiteSpace='wrap'>
          {intl.formatMessage(MSG.sellersMarketDescription)}
        </Text>
      </Flex>
    </Flex>
  )
}
